import {useState, useEffect} from "react"
import {Aff_question} from "./Aff_question"
import {MathJaxContext } from "better-react-mathjax";
import {Mode_classe} from "./Mode_classe"
import {affiche_param} from "../Fonctions"

export function Erreurs ({auth}) {

	const [selection, setSelection] = useState({
		classe:'',
		erreurs:'',
		activite:'',
		niv:'',
		msg:'',
		nb_activite:10
	})
	const [mode_classe, setMode_classe] = useState(false)

	const handleClick = (e) => {
		const param = e.target.id
		const erreurs = selection.erreurs
		const value = e.target.attributes.name.value
		setSelection({...selection, erreurs, [param]:value, niv:e.target.attributes.niv.value, msg:''})
	}

	const handleSubmit = (e) => {
		//console.log(selection.classe)
	  let	classe = e.target.innerText
	  let	msg=''
		let erreurs = ''
		let nb_activite = 10
	  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
	    method: 'POST',
	    //body: JSON.stringify({...auth, action:'recup_erreurs', classe:selection.classe})
	    body: JSON.stringify({...auth, action:'recup_erreurs', classe})
	  })
	  .then(response => response.json())
	  .then(data => {
	    //console.log('data', data)
	    //return
	    if(Array.isArray(data.questions)) {
	    	msg='<div class="info"><br>Il n\'y a pas d\'erreur répertoriée pour cette classe.<br><br></div>'
	    } else {erreurs = data}
	    setSelection({...selection, erreurs, classe, activite:'', msg, nb_activite})
	  })
	  .catch(err => console.log(err))
	}

	useEffect(()=>{
	  if(typeof window?.MathJax !== "undefined"){
	    window.MathJax.typeset()
	  }
	},[selection.activite]); // MathsJax 

	//const affiche_classes = (classes, classe_selected, handleClick) => Object.keys(classes).map((e, k)=><span key={k} className={'btn_param' + (classe_selected === e ? ' active' : '')} id='classe' onClick={handleClick}>{e}</span>)
	const affiche_activ_erreurs = () => {
		let result = ''
		let tab_activ = []
		if (selection.erreurs){
			//tab_activ = Object.keys(selection.erreurs.questions).map((niv, k)=><span key={k}></span>)
			Object.keys(selection.erreurs.questions).forEach(niv=>{
				Object.keys(selection.erreurs.questions[niv]).forEach((activite, k)=>{
					const activ = activite.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '')
					tab_activ.push(<span key={niv + k} name={activite} className={'btn_param' + (selection.activite === activite ? ' active' : '')} id='activite' title={activite} niv={niv} onClick={handleClick}>{auth.activite_faites[selection.classe][activite][0].title || (activ.length > 30 ? activ.slice(0,30)+'...' : activ)}</span>)
				})
			})
			let tab_activ2 = tab_activ.slice(0,selection.nb_activite)
			//  Gestion du btn '...'
			if(selection.nb_activite < 1000 && tab_activ.length > 10) {
				tab_activ2.push(<span className="btn_param" onClick={()=>{
	    							const nb = selection.nb_activite
	    							const add = Object.keys(auth.activite_faites[selection.classe]).length < nb ? 1000 : 10
	    							setSelection({...selection, nb_activite:nb+add > selection.nb_activite ? 1000 : nb+add})
	    						}}>...</span>)
			}
			//======================
			
			result = <span>
									<br/>Veuillez choisir une activité faite en {selection.classe}   : <br/>
									{tab_activ2}
							</span>
		}
		return result
	}

	//console.log('auth', auth)
	//console.log('auth.activite_faites[selection.classe]', auth.activite_faites[selection.classe])
	//console.log(selection.erreurs.questions[selection.niv][selection.activite])
	//console.log('selection.erreurs.questions', selection.erreurs.questions)
	//console.log('nb_activite', selection.nb_activite)
  return (
    <div className="content max" style={{textAlign:'left'}} >
    <h1>Les erreurs commises par les élèves...</h1>
    	Dans cette partie, visualisez les erreurs commises par vos élèves. <br/>
    	Pour chaque activité, les questions affichées sont classées du plus grand au plus petit nombre d'erreurs.<br/>
    	Choisir une classe : 
    	{affiche_param(auth.mes_classes, selection.classe, 'classe', handleSubmit)}
    	<br/>
    	{affiche_activ_erreurs()}

    	{<div dangerouslySetInnerHTML={{ __html:selection.msg}}></div>}

    	{
    		//Object.keys(auth.mes_classes).map((e, k)=><span key={k} className={'btn_param' + (selection.classe === e ? ' active' : '')} id='classe' onClick={handleSubmit}>{e}</span>)
    	}

    	{/*
    		selection.erreurs ? <div>
		    			<br/>Veuillez choisir une activité faite en {selection.classe}   : <br/><br/>
		    			{Object.keys(selection.erreurs.questions).map((niv, k)=><span key={k}>
		    				{Object.keys(selection.erreurs.questions[niv]).map((act, k2)=>k2 < selection.nb_activite && <span key={k2} className={'btn_param' + (selection.activite === act.replace('2e devoir mêmes notions__', '') ? ' active' : '')} id='activite' title={act} niv={niv} onClick={handleClick}>{auth.activite_faites[selection.classe][act.replace('2e devoir mêmes notions__', '')][0].title || (act.length > 30 ? act.slice(0,30)+'...' : act)}</span>)}
		    				</span>)}
		    			{selection.nb_activite < 1000 && <span className="btn_param" onClick={()=>{
		    							const nb = selection.nb_activite
		    							const add = Object.keys(auth.activite_faites[selection.classe]).length < nb ? 1000 : 10
		    							setSelection({...selection, nb_activite:nb+add > selection.nb_activite ? 1000 : nb+add})
		    						}}>...</span>
		    			}
		    		</div> : ''*/
    	}
    	{(selection.erreurs && selection.activite) && <div style={{position:'relative', height:'30px'}}> 
    				<div name="mode_classe" className="mode_classe" onClick={()=>setMode_classe(true)}></div>
    			</div>
    	}
    	<MathJaxContext>{(selection.erreurs && selection.activite) && Object.keys(selection.erreurs.questions[selection.niv][selection.activite]).sort((a,b)=>selection.erreurs[selection.niv][selection.activite][b]-selection.erreurs[selection.niv][selection.activite][a]).map((quest, kquest)=>
				<span key={kquest}>
    			<Aff_question question={selection.erreurs.questions[selection.niv][selection.activite][quest]} num_quest={selection.erreurs[selection.niv][selection.activite][quest]+' échecs : '} />
				</span>
					
				
    	)}</MathJaxContext> 

    	{mode_classe ? 
    	      <div className='modal active'>
    	          <div className="suppr_serie" onClick={e=>setMode_classe(false)}></div>
        				<Mode_classe auth={{...auth, titre:auth.activite_faites[selection.classe][selection.activite.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '')][0].title || (selection.activite.length > 30 ? selection.activite.slice(0,30)+'...' : selection.activite), questions:Object.values(selection.erreurs.questions[selection.niv][selection.activite])}} setMode_classe={setMode_classe} />
    	      </div> :''
    	}

    	{/*
    		selection.erreurs && Object.keys(selection.erreurs.questions).map((niv, k)=>
    			<div key={k}>
    				<b>Niveau {niv} :</b> <br/>
    				{Object.keys(selection.erreurs.questions[niv]).map((act, k2)=> 
    					<div key={k2} id="erreurs" onClick={e=>{
						    				document.querySelector('#erreurs .active')?.classList.remove('active')
						    				e.target.className = e.target.id === 'erreurs' ? 'active' : e.target.className
						    			}}>
    						<div dangerouslySetInnerHTML={{ __html:act.replaceAll('__', '<br>')}}></div>
    						<div>{selection.erreurs.questions[niv][act].map((quest, kquest)=>
    							<Aff_question key={kquest} question={quest} />
    							)}</div>

    					</div>
    					)
    				}
    			</div>
    			)*/
    	}
    </div>
  );
}